export default __webpack_public_path__ + "static/media/Lockred.29e83b61.svg";